import React from "react";
import { times } from "ramda";
import cn from "classnames";
import "./style.css";

const Timeline = ({ start = 2015, end = 2060 }) => (
  <div className="timeline">
    <div className="timeline__ticks">
      {times(
        n => (
          <span
            className={cn("timeline__tick", {
              "timeline__tick--large": !(n % 5),
            })}
          />
        ),
        end - start + 1
      )}
    </div>
    <div className="timeline__years">
      <span className="timeline__year">{start}</span>
      <span className="timeline__year">{end}</span>
    </div>

    <div className="timeline__marker" />
  </div>
);

export default Timeline;



// WEBPACK FOOTER //
// ./src/components/timeline/index.js